import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { slide as MenuComp } from 'react-burger-menu';
import './LeftMenu.css';

export default class LeftMenu extends Component {
  static propTypes = {
    actions: PropTypes.array,
    profile: PropTypes.obj,
    className: PropTypes.string,
    isOpen: PropTypes.bool
  }

  componentDidMount() {
    this.props.fetchData();
  }

  render() {
    return (
      <MenuComp onStateChange={this.props.onStateChange} customBurgerIcon={false} customCrossIcon={false} className={`LeftMenu ${this.props.className ? this.props.className : ''}`} isOpen={this.props.isOpen}>
        <div className="profile">
          <img className="circle" alt="" src={this.props.profile.img} />
          <h5>{this.props.profile.name}</h5>
          <p>{this.props.profile.job}</p>
        </div>
        <div className="actions">
          {this.props.actions.map(action => (
            <a {...action} onClick={() => {this.props.push(action.url); this.props.onCloseMenu(); } }>{action.title}<i className="fa fa-angle-right" aria-hidden="true"></i></a>
          ))}
        </div>
        <div className="footer">
          <p className="copyright">© Copyrights 1Screen 2017</p>
        </div>
      </MenuComp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LeftMenuComponent/LeftMenu.js